export const AUDIENCE_ANALYSIS = 'AUDIENCE ANALYSIS';
export const TIME_PERIOD = 'TIME PERIOD';
export const COMPARISON_PERIOD = 'COMPARISON PERIOD';
export const OVERALL_PERFORMANCE = 'OVERALL PERFORMANCE';
export const TABLE_PERIOD_COMPARE = 'TABLE PERIOD COMPARE';
export const TABLE_YTD = 'TABLE YTD';
export const TABLE_REGION = 'TABLE REGION';
export const WEEK_SUBSTRACTION_VALUE = 12;
export const CHANNEL_OPPS = 'CHANNEL OPPS';
export const SUB_BRANCH_DASH_OPPS_BY_CHANNEL = 'SUB BRANCH DASH OPPS BY CHANNEL';
export const OVERALL_PERFORMANCE_SUB_BRANCH = 'OVERALL PERFORMANCE SUB BRANCH';
export const PERFORMANCE_OVERVIEW_SUB_BRANCH = 'PERFORMANCE OVERVIEW SUB BRANCH';
